<div class="sidebar-wrapper">
  <div class="sidebar-header flex items-center gap-2">
    <div class="text-size_3xl font-semibold text-navy-900">{{ rfi()?.rfi_number }}</div>
    <app-styled-options-list
      (selectedOption)="handleOptionSelected($event)"
      [listItems]="menuOptions()"
      [disabledActionList]="disabledOptions()"
      [stopClickPropagation]="true"
    >
      <span class="icon-options-inverted text-blue-700 cursor-pointer text-xl"></span>
    </app-styled-options-list>
  </div>

  <div class="main-content mx-5 mt-0 p-0 flex flex-col">
    <app-underline-tabs [tabs]="tabs()" [(selectedTab)]="selectedTab"></app-underline-tabs>
    <div class="rfi-header">
      <div>
        <div class="text-size_xxl font-semibold">{{ rfi()?.subject }}</div>
        <div class="text-size_m font-normal">{{ rfi()?.project?.title }}</div>
      </div>
      <div>
        <app-status-block [status]="rfi()?.status" size="medium"></app-status-block>
      </div>
    </div>

    @if (selectedTab() === tabOptions().RFI_DETAILS) {
      <div class="rfi-content">
        <div class="details">
          <div class="detail-item">
            <div class="label">RFI ID</div>
            <div class="value">{{ rfiNumberOnly() }}</div>
          </div>
          <div class="detail-item">
            <div class="label">Due</div>
            <div class="value">{{ rfi()?.due_date | dayjsFormatter }}</div>
          </div>
          <div class="detail-item">
            <div class="label">RFI Manager</div>
            <div class="value">
              <span>{{ rfi()?.rfi_manager?.name }}</span>
              <span class="second-value">{{ rfi()?.rfi_manager?.company_name }}</span>
            </div>
          </div>

          <div class="detail-separator"></div>

          <div class="detail-item">
            <div class="label">Responsibility</div>
            <div class="value">
              <span>{{ rfi()?.rfi_responsible?.name }}</span>
              <span class="second-value">{{ rfi()?.rfi_responsible?.company_name }}</span>
            </div>
          </div>
          <div class="detail-item">
            <!--   todo       this is not sent, it's created at-->
            <div class="label">Sent</div>
            <div class="value">
              {{ rfi()?.created_at | dayjsFormatter }}
            </div>
          </div>
          <div class="detail-item">
            <div class="label">Answered</div>
            <div class="value">
              {{ rfi()?.manager_answer_status ?? 'Pending' }}
            </div>
          </div>
          <div class="detail-item">
            <div class="label">Answered By</div>
            <div class="value">
              @if (rfi()?.manager_answered_user) {
                <span>{{ rfi()?.manager_answered_user?.name }}</span>
                <span class="second-value">{{ rfi()?.manager_answered_user?.company_name }}</span>
              }
              @if (rfi()?.responsible_answered_user) {
                <span [ngClass]="{ 'mt-2': rfi()?.manager_answered_user }">{{
                  rfi()?.responsible_answered_user?.name
                }}</span>
                <span class="second-value">{{ rfi()?.responsible_answered_user?.company_name }}</span>
              }
              @if (!rfi()?.manager_answered_user && !rfi()?.responsible_answered_user) {
                <span>Pending</span>
              }
            </div>
          </div>

          <div class="detail-separator"></div>

          <div class="detail-item">
            <div class="label">Originator</div>
            <div class="value">
              <span>{{ rfi()?.rfi_originator?.name ?? 'Not specified' }}</span>
              @if (rfi()?.rfi_originator?.company_name) {
                <span class="second-value">{{ rfi()?.rfi_originator?.company_name }}</span>
              }
            </div>
          </div>

          <div class="detail-separator"></div>

          <div class="detail-item">
            <div class="label">Cost Impact</div>
            <div class="value">
              @if (rfi()?.estimated_cost) {
                {{ rfi()?.estimated_cost | money: 'comaSign' }}
              } @else {
                None
              }
            </div>
          </div>
          <div class="detail-item">
            <div class="label">Schedule Impact</div>
            <div class="value">
              @if (rfi()?.estimated_schedule) {
                {{ rfi()?.estimated_schedule }} day{{ rfi()?.estimated_schedule > 1 ? 's' : '' }}
              } @else {
                None
              }
            </div>
          </div>

          <div class="detail-item">
            <div class="label">Drawing</div>
            <div class="value">
              {{ rfi()?.drawing_id || '–' }}
            </div>
          </div>

          <div class="detail-item">
            <div class="label">Section Reference</div>
            <div class="value">
              {{ rfi()?.section_reference || '–' }}
            </div>
          </div>
        </div>
        <div class="question-column">
          <div class="title">
            <span>Question</span>
            <span
              class="icon text-size_title_l"
              [ngClass]="{
                'icon-shield-pending text-navy-500': rfi()?.status === 'draft',
                'icon-shield-approved text-green-400': rfi()?.status !== 'draft',
              }"
            ></span>
          </div>
          <div class="question-body">
            @if (isQuestionEditing()) {
              <app-floating-textarea
                class="flex-1"
                [(ngModel)]="questionText"
                [placeholder]="'Type your question here...'"
                name="answerText"
              >
              </app-floating-textarea>

              <app-input-upload
                [allowMultipleFiles]="true"
                [files]="questionFiles()"
                (filesChanged)="onQuestionFilesChange($event)"
                (removeFile)="removeQuestionFile($event)"
                placeholder="Click to upload files or drag & drop"
              ></app-input-upload>
              <div class="flex justify-between my-4">
                <app-simple-button
                  [disabled]="questionFilesUploading()"
                  (click)="initiateQuestionSave()"
                  buttonStyle="color_secondary_border"
                  >Save Draft</app-simple-button
                >
                <app-simple-button
                  [disabled]="questionFilesUploading()"
                  (click)="initiateQuestionSave()"
                  buttonStyle="color_accent_filled"
                  >Submit</app-simple-button
                >
              </div>
            } @else {
              <div class="question-text">
                {{ rfi()?.question }}
              </div>
              <div class="files-container">
                @for (file of rfi()?.question_files; track file.id) {
                  <app-file-card class="min-w-28" [file]="file"></app-file-card>
                }
              </div>
            }
          </div>
        </div>
        <div class="answer-column">
          <div class="title">
            <span>Answer</span>
            <span
              class="icon text-size_title_l"
              [ngClass]="{
                'icon-shield-pending text-navy-500': rfi()?.manager_answer_status !== 'approved',
                'icon-shield-approved text-green-400': rfi()?.manager_answer_status === 'approved',
              }"
            ></span>
          </div>
          <div class="answer-body">
            @if (isAnswerEditing()) {
              <app-floating-textarea
                class="flex-1"
                [(ngModel)]="answerText"
                [placeholder]="'Type your answer here...'"
                name="answerText"
              >
              </app-floating-textarea>

              <app-input-upload
                [allowMultipleFiles]="true"
                [files]="answerFiles()"
                (filesChanged)="onAnswerFilesChange($event)"
                (removeFile)="removeAnswerFile($event)"
                placeholder="Click to upload files or drag & drop"
              ></app-input-upload>
              <div class="flex justify-between gap-2 my-4">
                @if (!userAnswerStatus() || userAnswerStatus() === 'draft') {
                  <app-simple-button
                    class="flex-1"
                    [disabled]="answerFilesUploading()"
                    (click)="initiateAnswerSave('draft')"
                    buttonStyle="color_secondary_border"
                    >Save Draft
                  </app-simple-button>
                }
                <app-simple-button
                  class="flex-1"
                  [disabled]="answerFilesUploading()"
                  (click)="initiateAnswerSave('submitted')"
                  buttonStyle="color_accent_filled"
                  >Submit</app-simple-button
                >
              </div>
            } @else if (rfi()?.manager_answer || rfi()?.responsible_answer) {
              @if (rfi()?.responsible_answer) {
                <div class="user-answer">
                  <div class="answer-creator">
                    {{ rfi()?.responsible_answered_user?.name }}, {{ rfi()?.responsible_answered_user?.company_name }}
                  </div>
                  <div class="answer-text">
                    {{ rfi().responsible_answer }}
                  </div>
                </div>
              }
              @if (rfi()?.manager_answer) {
                <div class="user-answer">
                  <div class="answer-creator">
                    {{ rfi()?.manager_answered_user?.name }}, {{ rfi()?.manager_answered_user?.company_name }}
                  </div>
                  <div class="answer-text">
                    {{ rfi().manager_answer }}
                  </div>
                </div>
              }
              <div class="files-container">
                @for (file of rfi()?.answer_files; track file.id) {
                  <app-file-card [file]="file"></app-file-card>
                }
              </div>
            } @else {
              @for (option of answerOptions(); track option.value) {
                <div
                  class="answer-option-item"
                  (click)="handleOptionSelected(option.value)"
                  [ngClass]="[option.class, option.disabled ? 'disabled text-navy-500' : '']"
                >
                  <span class="icon" [ngClass]="[option.icon]"></span>
                  <span>{{ option.value }}</span>
                </div>
              } @empty {
                <div class="no-answer-text">No answer has been provided yet.</div>
              }
            }
          </div>
        </div>
      </div>
    } @else if (selectedTab() === tabOptions().DISCUSSIONS) {
      <div class="rfi-content discussions">
        <div class="column details participants">
          @for (company of rfiCompanies(); track company.company_name) {
            <app-expansion-panel-v2 class="company-expansion-panel" [expanded]="isExpanded()[company.company_name]">
              <div (click)="toggleCompanyExpand(company)" header-row class="company-header">
                @if (isExpanded()[company.company_name]) {
                  <span class="icon icon-collapse-square"></span>
                } @else {
                  <span class="icon icon-expand-square"></span>
                }
                <span class="company-name">{{ company.company_name }}</span>
              </div>
              <div content-row>
                @for (user of company.users; track user.id) {
                  <div class="company-user">
                    <span class="empty-box"></span>
                    <span class="flex flex-col">
                      <span class="text-size_l font-semibold">{{ user.name }}</span>
                      <span class="text-size_s">{{ user.type.name | userType }}</span>
                    </span>
                  </div>
                }
              </div>
            </app-expansion-panel-v2>
          }
        </div>
        <div class="discussions-column">
          @if (selectedMessagingView() === MESSAGING_VIEWS().DISCUSSION_THREAD_VIEW) {
            <app-discussion-thread-view class="flex-1 min-h-0"></app-discussion-thread-view>
          } @else {
            <app-discussions-view [hideHeader]="true" class="flex-1 min-h-0"></app-discussions-view>
          }
        </div>
      </div>
    }
  </div>
</div>
